module.exports = require("npm:isarray@1.0.0/index.js");